import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProvaService } from '../../../services/prova-service';
import { Prova } from '../../../models/prova';

@Component({
  selector: 'app-visualizar-prova',
  templateUrl: './visualizar-prova.component.html',
  styleUrls: ['./visualizar-prova.component.scss']
})
export class VisualizarProvaComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  id: string;
  prova: Prova;
  constructor(private route: ActivatedRoute,
    private router: Router, private provaService: ProvaService) {
  }

  ngOnInit() {
    if (!this.route.snapshot.params['id']) {
      this.router.navigate(['/dashboard']);
    }
    this.id = this.route.snapshot.params['id'];
    this.provaService.getById(this.id).then(res => {
      this.prova = res.val();
      this.prova.id = this.id;
    });
  }

  isNull(q) {
    if (!q || q.toString().trim().length === 0 || q.toString().trim() === '-') {
      return true;
    }
    return false;
  }

  downloadPDF() {
    let printContents, popupWin;
    printContents = document.getElementById('content').innerHTML;
    popupWin = window.open('', '_blank', '');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    /*const doc = new jsPDF();

    const specialElementHandlers = {
      '#editor': function (element, rendered) {
        return true;
      }
    };
    const content = this.content.nativeElement;

    console.log(content.innerHTML);
    doc.fromHTML(content.innerHTML, 15, 15, {
    });
    doc.save('prova.pdf');*/
  }

  getProva(p) {
    const x = p.split(' / ');
    console.log(x);
    return x[0];
  }

}
